<template>
  <div class="btn-group">
    <button
      data-toggle="dropdown"
      class="btn btn-primary btn-sm dropdown-toggle"
    >
      {{ buttonText }}
    </button>

    <ul class="dropdown-menu">
      <li v-for="(item, index) in items" :key="index" @click="onItemClick(item)">
        <a class="dropdown-item" href="#">{{ item.text }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Dropdown',
  props: {
    buttonText: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
  },
  methods: {
    onItemClick(item) {
      this.$emit('item-click', item);
    },
  },
};
</script>
